"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSportActivitiesPerDay = exports.getSportActivities = void 0;
exports.getSportActivities = `
    query sportActivities($userId: Int!, $range: RangeOfString!) {
        sportActivities(userId: $userId, range: $range){
        id
        occurredAt {
            iso8601
        }
        exertion {
            percentage
        }
        duration {
            minutesInTotal
        }
        note
        type {
            id
            name
            isCustom
            icon {
            unicode
            url
            alt
            }
        }
    }
}    
`;
exports.getSportActivitiesPerDay = `
    query sportActivities($userId: Int!, $range: RangeOfString!) {
        sportActivities(userId: $userId, range: $range){
        id
        occurredAt {
            iso8601
        }
    }    
}    
`;
//# sourceMappingURL=getSportActivities.js.map